var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { inject } from 'mobx-react';
import { GcDefaultHeader } from '../gc-default-header';
var BEXHeader = /** @class */ (function (_super) {
    __extends(BEXHeader, _super);
    function BEXHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BEXHeader.prototype.render = function () {
        var _a = this.props, context = _a.context, globalComponentsContext = _a.globalComponentsContext, analytics = _a.analytics, page = _a.page, minimal = _a.minimal, simplified = _a.simplified, fullWidth = _a.fullWidth;
        var _b = globalComponentsContext.header, l10n = _b.l10n, logoUrl = _b.logoUrl, cobrandPosition = _b.cobrandPosition;
        return (React.createElement(GcDefaultHeader, { context: context, globalComponentsContext: globalComponentsContext, analytics: analytics, page: page, l10n: l10n, logoUrl: logoUrl, minimal: minimal, simplified: simplified, cobrandPosition: cobrandPosition, fullWidth: fullWidth }));
    };
    BEXHeader = __decorate([
        inject('context', 'globalComponentsContext', 'analytics', 'page')
    ], BEXHeader);
    return BEXHeader;
}(React.Component));
export { BEXHeader };
//# sourceMappingURL=template-bex.js.map